// extracted by mini-css-extract-plugin
module.exports = {"root":"ShutdownAttachments_root__2OWbH"};